import { render, staticRenderFns } from "./Termos.vue?vue&type=template&id=38058f76&scoped=true&"
import script from "./Termos.vue?vue&type=script&lang=js&"
export * from "./Termos.vue?vue&type=script&lang=js&"
import style0 from "./Termos.vue?vue&type=style&index=0&id=38058f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38058f76",
  null
  
)

export default component.exports